import React from 'react';

import {
  useTriggerWorkflowEventFailMutation,
  useTriggerWorkflowEventProcessMutation,
} from '@dashboard/generated/wp/administrator';
import { useCurrentUserQuery } from '@dashboard/generated/wp/authentication';
import { useWorkflowEventQuery } from '@dashboard/generated/wp/platform';
import { Alert, Box, Button, Stack, Typography } from '@mui/material';

import { DateFormatter } from '@waypoint/react/formatters';

type Props = {
  id: string;
};

export default function AdministratorActions({ id }: Props) {
  const [triggerFail, { loading: failDisabled }] = useTriggerWorkflowEventFailMutation();
  const [triggerProcess, { loading: processDisabled }] = useTriggerWorkflowEventProcessMutation();
  const { data: currentUserData } = useCurrentUserQuery();
  const { data } = useWorkflowEventQuery({ variables: { id } });

  if (currentUserData?.currentUser.role !== 'ADMIN') {
    return null;
  }

  const model = data?.WorkflowEvent;
  if (!model) {
    return null;
  }
  if (model.status === 'SUCCEEDED') {
    return null;
  }

  const onProcessClick = () => {
    triggerProcess({ variables: { id: model.id } });
  };
  const onFailClick = () => {
    triggerFail({ variables: { id: model.id } });
  };

  return (
    <Alert variant="standard" severity="warning" sx={{ mb: 1 }}>
      <Typography variant="h6" gutterBottom>
        Administrator tools
      </Typography>
      <Box>
        <p>Status: {model.status}</p>
        <p>
          Created at: <DateFormatter template="full" value={model.createdAt} />
        </p>
        <Stack direction="row" spacing={1}>
          <Button variant="contained" disabled={processDisabled} onClick={onProcessClick}>
            Process
          </Button>
          <Button variant="contained" disabled={failDisabled} onClick={onFailClick}>
            Fail
          </Button>
        </Stack>
      </Box>
    </Alert>
  );
}
